// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1u2vB","label":"styles_label__3eSjm"};